/**
 * Convierte texto de importe (coma o punto decimal) a menor unidad (p. ej. céntimos).
 * Ej. "12,50" / "12.50" → 1250. Entrada vacía o inválida → null.
 */
export function parseAmountToMinor(input: string): number | null {
  const trimmed = input.trim().replace(/\s/g, "");
  if (!trimmed) return null;
  const normalized = trimmed.replace(",", ".");
  if (!/^\d+(\.\d+)?$/.test(normalized)) return null;
  const major = Number.parseFloat(normalized);
  if (!Number.isFinite(major) || major < 0) return null;
  return Math.round(major * 100);
}

export function minorToMajorInputValue(amountMinor: number): string {
  return (amountMinor / 100).toFixed(2);
}
